import { Box } from '@mui/material'

import { Celula } from 'components/DetailSummary'
import MerchantBadge from 'components/MerchantBadge'

import { useDetailCompany } from './useDetailCompany'

/**
 * SC-10999: célula "Empresa" da grade de detalhes (cobrança, recorrência).
 * Só aparece na visão multi-empresas.
 */
const DetailCompanyCell = ({ recordUuid }: { recordUuid?: string | null }) => {
  const merchant = useDetailCompany(recordUuid)

  if (!merchant) return null

  // Duas colunas da grade: numa só (140px) o nome da empresa era cortado.
  // No celular a grade pode ter uma coluna só, e `span 2` criaria uma coluna
  // implícita estourando a largura; lá a célula ocupa a linha inteira.
  return (
    <Box sx={{ gridColumn: { xs: '1 / -1', sm: 'span 2' }, minWidth: 0 }}>
      <Celula label="Empresa">
        <MerchantBadge
          name={merchant.name}
          logoUrl={merchant.logo_url}
          size={20}
          variant="smBold"
        />
      </Celula>
    </Box>
  )
}

export default DetailCompanyCell
